<template>
    <div class="proposal-mobile-details">
        <div class="header">
            Детали заявки
            <font-awesome-icon
                @click="$emit('close')"
                class="icon close"
                icon="times"
                :style="{color: '#98A0A9'}"
            ></font-awesome-icon>
        </div>
        <div class="card">
            <Logs></Logs>
            <CreateComment v-if="isCommentsEnabled"></CreateComment>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import Logs from './Logs';
import CreateComment from './CreateComment';

export default {
    name: 'MobileDetails',
    components: {
        Logs,
        CreateComment,
    },
    data: () => ({
    }),
    computed: {
        ...mapGetters('proposals', [
            'proposalStatus',
        ]),
        ...mapState('proposals', [
            'proposal',
            'proposalError',
            'isCommentsEnabled',
        ]),
    },
    props: {
    },
    methods: {
    },
    async mounted() {
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../styles/rem';

    .header {
        position: relative;
        text-align: center;
        font-weight: 600;
        font-size: mrem(18);
        line-height: mrem(40);
        height: mrem(40);
        color: #4663AB;
        box-shadow: 0 mrem(2) mrem(8) 0 rgba(155, 161, 166, 0.23626);
        margin-bottom: mrem(8);

        .close {
            position: absolute;
            top: mrem(11);
            right: mrem(21);
        }
    }

    .proposal-mobile-details {
        width: 100%;
        position: absolute;
        top: 15rem;
        min-height: calc(100vh - 15rem);
        background: #FFFFFF;
        z-index: 10;
        .card {
            background: #FFFFFF;
            backdrop-filter: blur(rem(4));
            border-radius: mrem(4);
            margin-bottom: 0;
            padding: 0 mrem(16);
        }
    }
</style>
